import { render } from "./FilterByYear.vue?vue&type=template&id=16aff12a"
import script from "./FilterByYear.vue?vue&type=script&lang=js"
export * from "./FilterByYear.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__